import {useEffect, useState} from 'react';
import {subscribeToUserDisclosuresForReview} from '../../../../../firebase/firestore/disclosures';

/**
 * Subscribe to disclosure-type products that are awaiting review.
 */
export const useDisclosuresForReview = (userId) => {
    const [loading, setLoading] = useState(true);
    const [reports, setReports] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!userId) {
            setLoading(false);
            return;
        }

        setLoading(true);
        setError(null);

        const unsubscribe = subscribeToUserDisclosuresForReview(
            userId,
            (data) => {
                setReports(data);
                setLoading(false);
            },
            (err) => {
                console.error('Failed to subscribe to disclosures for review', err);
                setError(err);
                setLoading(false);
            }
        );

        return () => {
            try {
                unsubscribe?.();
            } catch (e) {
                // noop
            }
        };
    }, [userId]);

    return {reports, loading, error};
};
